/**
 * BasicInfoTab — Area details, residents list, and area groups.
 */

import { Link } from 'react-router-dom';

const BasicInfoTab = ({
  areaName, areaTypeName, buildingName, maxOccupancy,
  residents, areaGroups, loading, editRights, onEdit,
}) => {
  return (
    <>
      {/* Area Details */}
      <div className="pp-section">
        <div className="pp-section__header">
          <h3 className="pp-section__title">Area Details</h3>
          <div className="pp-section__actions">
            {editRights && (
              <button className="dp-btn dp-btn--secondary dp-btn--sm" onClick={onEdit}>
                ✎ Edit
              </button>
            )}
          </div>
        </div>
        <div className="pp-section__body">
          <div className="pp-field-grid">
            <div className="pp-field">
              <span className="pp-field__label">Area Name</span>
              <span className="pp-field__value">{areaName || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Area Type</span>
              <span className="pp-field__value">{areaTypeName || '—'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Building</span>
              <span className="pp-field__value">{buildingName || 'No Building'}</span>
            </div>
            <div className="pp-field">
              <span className="pp-field__label">Max Occupancy</span>
              <span className="pp-field__value">{maxOccupancy || '—'}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Residents */}
      <div className="pp-section">
        <div className="pp-section__header">
          <h3 className="pp-section__title">
            Residents
            <span className={"pp-section__count"}>({residents?.length})</span>
          </h3>
        </div>
        <div className="pp-section__body">
          {residents?.length > 0 ? (
            <div className="ap-residents-list">
              {residents.map((r, idx) => (
                <Link
                  key={r.resident_id || idx}
                  to={`/community/residents/${r.resident_id}`}
                  className="ap-resident-chip"
                >
                  {r.resident_name || r.resident_first_name
                    ? `${r.resident_first_name || ''} ${r.resident_last_name || ''}`.trim()
                    : `Resident ${r.resident_id}`}
                </Link>
              ))}
            </div>
          ) : (
            <span className="dp-cell-text dp-cell-text--muted">No residents assigned</span>
          )}
        </div>
      </div>

      {/* Area Groups */}
      <div className="pp-section">
        <div className="pp-section__header">
          <h3 className="pp-section__title">
            Area Groups
            <span className={"pp-section__count"}>({areaGroups?.length})</span>
          </h3>
        </div>
        <div className="pp-section__body">
          {areaGroups?.length > 0 ? (
            <div className="pp-groups-list">
              {areaGroups.map((g, idx) => (
                <span key={g.area_group_id || idx} className="pp-group-tag">
                  {g.area_group_name || g.group_name || `Group ${g.area_group_id}`}
                </span>
              ))}
            </div>
          ) : (
            <span className="dp-cell-text dp-cell-text--muted">No groups assigned</span>
          )}
        </div>
      </div>
    </>
  );
};

export default BasicInfoTab;
